module.exports = __webpack_public_path__ + "img/symbol_10.b7dc7dd6.png";